import { isValid, parseISO } from 'date-fns'

export const handleObj = (guest, booking, guests) => {
  return {
    guest,
    booking,
    guests,
  }
}

export function not(a: number[], b: number[]) {
  return a.filter(value => b.indexOf(value) === -1)
}

export function intersection(a: number[], b: number[]) {
  return a.filter(value => b.indexOf(value) !== -1)
}

export function union(a: number[], b: number[]) {
  return [...a, ...not(b, a)]
}

export const PaymentMode = [
  {
    value: 'Cash',
    name: 'Cash',
  },
  {
    value: 'Card',
    name: 'Credit/Debit Card',
  },
  {
    value: 'CityLedger',
    name: 'CityLedger',
  },
  {
    value: 'Cheque',
    name: 'Cheque',
  },
  {
    value: 'BankTt',
    name: 'Bank TT',
  },
  // {
  //   value: 'Online',
  //   name: 'Online',
  // },

  {
    value: 'Voucher',
    name: 'Voucher',
  },
  {
    value: 'Other',
    name: 'Other',
  },




]

export const CheckOutAdjPaymentMode = [
  {
    value: 'Cash',
    name: 'Cash',
  },
  {
    value: 'Card',
    name: 'Credit/Debit Card',
  },

  {
    value: 'CityLedger',
    name: 'CityLedger',
  },

  {
    value: 'BankTt',
    name: 'Bank TT',
  },
  // {
  //   value: 'Online',
  //   name: 'Online',
  // },

  {
    value: 'Voucher',
    name: 'Voucher',
  },
  {
    value: 'Other',
    name: 'Other',
  },

]
export const FrontDeskType = {
  DueIn: 'Due In',
  WalkIn: 'Walk In',
  DueOut: 'Due Out',
  RoomAssignment: 'Room Assignment',
  InHouse: 'In House',
  Deposit: 'Deposit',
  RoomUpgrade: 'Room Upgrade',
  ExtendStay: 'Extend Stay',
}
export const DepositType = [
  { value: 'SecurityDeposit', name: 'Security Deposit' },
  { value: 'KeyCardDeposit', name: 'Key Card Deposit' },
]
export const DocumentType = {
  Receipt: 'Receipt',
  RegCard: 'Registration Card',
  RefundVoucher: 'Refund Voucher',
  Invoice: 'Invoice',
  Folio: 'Folio',
}

export const CardType = [
  'Visa Card',
  'Master Card',
  'American Express Card',
  'Diners Card',
  'JCB Card',
  'UNION PAY',
  'Debit Card',
  'E-Wallet',
]
export const cardType = [
  { name: 'Visa Card', value: 'VisaCard' },
  { name: 'Master Card', value: 'MasterCard' },
  { name: 'American Express Card', value: 'American Express Card' },
  { name: 'Diners Card', value: 'DinersCard' },
  { name: 'JCB Card', value: 'JCBCard' },
  { name: 'UNION PAY', value: 'UNION PAY' },
  { name: 'Debit Card', value: 'DebitCard' },
  { name: 'E-Wallet', value: 'EWallet' },
]
export const ChargesType = {
  LateCheckOut: 'Late CheckOut',
  ExtendStay: 'Extend Stay',
  RoomUpgrade: 'Room Upgrade',
}

export function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || ''
  sliceSize = sliceSize || 512

  var byteCharacters = atob(b64Data)
  var byteArrays = []

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize)

    var byteNumbers = new Array(slice.length)
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    var byteArray = new Uint8Array(byteNumbers)

    byteArrays.push(byteArray)
  }

  var blob = new Blob(byteArrays, { type: contentType })
  return blob
}


 
export function parsePmsDateTime(input: unknown): Date {
  if (input == null || input === '') return new Date(NaN)
  if (input instanceof Date) return input
  if (typeof input === 'number') return new Date(input)
  const s = String(input).trim()
  const isoStart = s.match(/^(\d{4}-\d{2}-\d{2})(?:[T\s](.+))?$/)
  if (isoStart) {
    const rest = isoStart[2]
    const iso = rest != null ? `${isoStart[1]}T${rest}` : isoStart[1]
    const d = parseISO(iso)
    if (isValid(d)) return d
  }
  return new Date(s)
}

export const KeyCardOption = [
  {
    label: 'New',
    value: 'N',
  },
  {
    label: 'Duplicate',
    value: 'D',
  },
  {
    label: 'Erase',
    value: 'E',
  },
  {
    label: 'Read Card',
    value: 'R',
  },
  {
    label: 'Generate QR',
    value: 'G',
  },
]

function resolveFirstValidPmsDate(...candidates: unknown[]): Date {
  for (const candidate of candidates) {
    if (candidate == null || candidate === '') continue
    const parsed = parsePmsDateTime(candidate)
    if (isValid(parsed)) return parsed
  }
  return new Date()
}

/**
 * Departure calendar date (local) + hotel CheckOutTime wall clock (local).
 * Uses parsePmsDateTime so ISO / date-only strings behave like other FD keycard code.
 * Assumes browser TZ matches hotel ops TZ (same as ChargesTypePayment).
 * Always returns a valid Date (falls back through extra departure candidates, then today).
 */
export function departureWithHotelCheckOutTime(
  departureDate: unknown,
  hotelCheckOutTime?: string | Date | null,
  ...fallbackDepartureDates: unknown[]
): Date {
  const regDepDate = resolveFirstValidPmsDate(
    departureDate,
    ...fallbackDepartureDates
  )
  if (!hotelCheckOutTime) {
    return regDepDate
  }
  const hotelTime = parsePmsDateTime(hotelCheckOutTime)
  if (!isValid(hotelTime)) {
    return regDepDate
  }
  return new Date(
    regDepDate.getFullYear(),
    regDepDate.getMonth(),
    regDepDate.getDate(),
    hotelTime.getHours(),
    hotelTime.getMinutes(),
    0,
    0
  )
}

export function formatDateToYYMMDDHHmm(date) {
  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  const yy = String(date.getFullYear()).slice(-2)
  const MM = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  const hh = String(date.getHours()).padStart(2, '0')
  const mm = String(date.getMinutes()).padStart(2, '0')

  return `${yy}${MM}${dd}${hh}${mm}`
}
